import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import styled from "styled-components";
import { Typography } from "@creditsafe/ui-components";
import { useTranslation } from "react-i18next";
import type MenuItemType from "../../types/MenuItemType.type";

const MenuWrapper = styled(Menu)`
  ul {
    padding: 0;
  }

  .menu-item {
    border-bottom: 1px solid rgb(234, 234, 234);
    padding: 4px 6px;
    margin: 0 4px;
  }
`;

const TableMenu: React.FC<{
  menuItems: MenuItemType[];
  onMenuClick: (_action: string) => void;
}> = ({ menuItems, onMenuClick }) => {
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>();
  const menuOpen = Boolean(anchorElement);

  const { t: translate } = useTranslation(["common"]);

  const handleMenuButtonClick = (
    event: React.MouseEvent<HTMLElement>
  ): void => {
    setAnchorElement(event.currentTarget);
  };

  const handleMenuClose = (): void => {
    setAnchorElement(null);
  };

  const handleMenuAction = (item: string): void => {
    onMenuClick(item);
    setAnchorElement(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={menuOpen ? "long-menu" : undefined}
        aria-expanded={menuOpen ? "true" : undefined}
        aria-haspopup="true"
        onClick={handleMenuButtonClick}
      >
        <MoreHorizIcon />
      </IconButton>
      <MenuWrapper
        id="long-menu"
        MenuListProps={{
          "aria-labelledby": "long-button",
          "aria-label": `table-menu-wrapper`,
        }}
        anchorEl={anchorElement}
        open={menuOpen}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: 160,
            minWidth: 100,
          },
        }}
      >
        {menuItems.map(
          (menuItem) =>
            !menuItem.hidden && (
              <MenuItem
                className="menu-item"
                aria-label={`table-menu-item-${menuItem.key}`}
                key={menuItem.key}
                onClick={() => handleMenuAction(menuItem.key)}
              >
                <Typography variant={"body2"}>
                  {translate(menuItem.label, { ns: "common" })}
                </Typography>
              </MenuItem>
            )
        )}
      </MenuWrapper>
    </>
  );
};

export default TableMenu;
